import LanguageController from './LanguageController'

export default LanguageController



// WEBPACK FOOTER //
// ./src/modules/Controllers/Language/LanguageController/index.js